export const theme = {
  colors: {
    primary: "#2A71D4",
    white: "#ffffff",
    gray: "#333333",
    lightGray: "#515151",
    grayAlpha: "#333333de",
    lightGrayAlpha: "#515151de",
    darkBlueAlpha: "#062b5408",
    darkBlueAlphaMedium: "#062b548a",
    blue: "#062B54",
    paleBlue: "#F8FAFD",
    blackAlpha: "#0000004d",
    navyBlue: "#D5EDFE",
  },
  spacing: 4,
  contentWidth: `${1280 - 24 * 2}`,
};
